import '../styles/baseline.scss';
import '../styles/tokens/ps-light.css';
import '../styles/tokens/ps-dark.css';
import '../styles/tokens/sisal-light.css';
import '../styles/tokens/sisal-dark.css';
import type { ReactNode } from 'react';
import { createContext } from 'react';

import type { Theme } from './fusionThemes';

interface ThemeContextValue {
  theme: Theme;
}

export const ThemeContext = createContext<ThemeContextValue>({
  theme: 'ps-light'
});

export interface Props {
  theme: Theme;
  children: ReactNode;
}

const ThemeProvider = ({ theme, children }: Props) => (
  <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
);

export default ThemeProvider;
